import { getAPIFromDomain } from "../../lib/api";

export type Country = {
  name: { common: string; official: string };
  flag: string;
  cca3: string;
};
export const fetchCountryIndex = async (): Promise<Country[]> => {
  // open-source country REST API https://restcountries.com
  const api = getAPIFromDomain(undefined, 1, "https://restcountries.com");
  const res = await api.get("/v3.1/all", { params: { fields: "name,cca3,flag" } }); // will return error 400 if no fields are specified. https://gitlab.com/restcountries/restcountries/-/issues/265
  return res.data;
};
